import React from 'react';

import styles from './errorMessageStyles.scss';

interface ErrorMessageProps {
  children?: React.ReactNode;
  className?: string;
  title?: string;
}

const ErrorMessage: React.FunctionComponent<ErrorMessageProps> = ({
  children,
  className,
  title
}): React.ReactElement => {
  const titleEl = title ? <h3 className={styles.errorMessageTitle}>{title}</h3> : '';
  return (
    <div className={styles.errorMessage + ` ${className}`}>
      {titleEl}
      {children}
    </div>
  );
};

export default ErrorMessage;
